<template>
    <div style="position: relative" component_name="ImageUpload">
        <img :src="url" :width="width" :height="height" @click="showImgUploadWindow" style="cursor: pointer;">
        <span :style="{position:'absolute',color: 'red',left:width+'px',top:'0px','font-size':'18px','margin-left':'2px','cursor':'pointer'}" @click="removeImg"><i class="fa fa-times" aria-hidden="true"></i></span>
        <input type="file" style="display: none" ref="xunw_image_upload" @change="selectedImgFile" />
    </div>
</template>
<script>
    /**
     * 组件名称：图片上传组件
     * 特性：
     *  1、支持v-model双向绑定，可以作为普通表单元素进行操作
     */
    export default {
        name: "ImageUpload",
        props:{
            value:String,
            accept:{//可以接受的图片类型,默认只可以传图片
                type:Array,
                default:()=>['png','jpg','jpeg','gif']
            },
            limitSize:{//单位:字节
                type:Number,
                required:false
            },
            width:{//长度
                type:String,
                default:"80px"
            },
            height:{//宽度
                type:String,
                default:"80px"
            },
			isXcpz:{//是否是本人的登记照，true  表示  是  false:不是，如果是 那么后台会自动校验登记照的尺寸必须是151*201
			    type:Boolean,
			    default:false//默认不是登记照
			}
        },
        data:function(){
            return {
                url: null,
            }
        },
        mounted:function(){
            this.url = this.value || require("@/assets/img_upload_btn.png");
        },
        watch: {
            // 监听prop的变
            value: function() {
                if(!this.value){
                     this.url = require("@/assets/img_upload_btn.png");
                }
                else{
                    if(!this.url){
                        this.url = this.value;
                    }
                    if(this.value!=this.url){
                        this.url = this.value;
                    }
                }
            }
        },
        methods:{
            removeImg:function(){
                this.url = null;
                this.$refs['xunw_image_upload'].value = '';
                this.$emit('input',null);
                this.url =  require("@/assets/img_upload_btn.png");
            },
            selectedImgFile:function(){
                let file = this.$refs['xunw_image_upload'].files[0];
                if(!file){
                    return;
                }
                let input_file_name = file.name;
                this.accept = this.accept || ['png','jpg','jpeg','gif'];
                //判定文件的后缀
                let index = input_file_name.lastIndexOf(".");
                let suffix = input_file_name.substring(index+1);
                let check = this.accept.filter(x=>x.toLowerCase() == suffix.toLowerCase());
                if(!check || check.length == 0){
                    let file_input_err_msg = '图片格式错误,不支持的图片扩展名:'+suffix;
                    this.$error(file_input_err_msg);
                    return;
                }
                //判定文件的大小
                if(this.limitSize){
                    if(file.size>this.limitSize){
                        let file_input_err_msg = '图片大小超过限制';
                        this.$error(file_input_err_msg);
                        return;
                    }
                }
                if(file.size == 0){
                    this.$error('图片大小不能够是0字节');
                    return;
                }
                else{
                    let formdata = new FormData();
                    formdata.append("image",file);
					formdata.append("isXcpz",this.isXcpz);
                    this.$http.post("/htgl/common/uploadImage",formdata,{'Content-Type':'multipart/form-data'}).then(res=>{
                        if(res && res.code==0){
                            this.url = res.data.url || '';
                            this.$emit('input',this.url);
                            console.log('-------res for uplaod image:',res.data);
                        }
                    })
                }
            },
            showImgUploadWindow:function(){
                this.$refs['xunw_image_upload'].dispatchEvent(new MouseEvent('click'));
            }
        }
    }
</script>

<style scoped>

</style>